
import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import { useDispatch, useSelector } from 'react-redux';
import Paginacao from "../../../../../utils/paginacao";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isTablet } from 'react-device-detect';
import RegisterAccess from "../../../../../utils/registerAccess";
import ListaInspecoes from "../listaInspecoes";
import { temPermissao } from "../../../../../utils/permissoes";
import TabelaLoading from "../../../../../load/tabelaLoading";


export default function InspeccaoAgendadaArea() {
  const navigate = useNavigate()
  const user = useSelector(state => state.account.user);
  const [tipo, setTipo] = useState('')
  const [perPage, setPerPage] = useState(50)
  const [order, setOrder] = useState('')
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState('')
  const dispatch = useDispatch();
  const [inspeccoes, setInspeccoes] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [inspectorId, setInspectorId] = useState('')
  const [provincia, setProvincia] = useState('')

  useEffect(() => {

    if (isTablet || user?.funcao === 'Inspector') {
      navigate('/admin/minhas-inspeccoes')
    }

    if (temPermissao(user, ['licenciamentoEstabelecimentoInspeccaoAgendada'])) {
    } else {
      dispatch({
        type: 'alert',
        payload: { alert: 'Acesso negado' },
      });
      navigate('/admin/menu')
    }

    setLoading(true)
    setInspeccoes('')
    const fetchInspeccoesDeduplicadas = async () => {
      try {
        const todasInspeccoes = [];
        let currentPage = page || 1;
        let hasNextPage = true;

        while (hasNextPage) {
          const response = await api.get(`/inspeccaos?page=${currentPage}&status=Não Realizada&perPage=${perPage}&sortBy=nome:${order}&inspectorId=${inspectorId}&provincia=${provincia}&tipoId=${tipo}`);
          const data = response.data || {};

          todasInspeccoes.push(...(data.inspeccaos || []));

          if (data.hasNextPage && data.nextPage) {
            currentPage = data.nextPage;
          } else {
            hasNextPage = false;
          }
        }

        const inspeccoesUnicas = todasInspeccoes.filter((inspeccao, index, lista) => {
          const idEstabelecimento = inspeccao?.estabelecimento?._id;
          if (!idEstabelecimento) return true;
          return lista.findIndex((item) => item?.estabelecimento?._id === idEstabelecimento) === index;
        });

        const totalItems = inspeccoesUnicas.length;
        const totalPages = Math.max(Math.ceil(totalItems / perPage), 1);
        const paginaActual = Number(page) || 1;
        const paginaSegura = Math.min(Math.max(paginaActual, 1), totalPages);

        if (paginaSegura !== paginaActual) {
          setPage(paginaSegura);
          return;
        }

        const inicio = (paginaSegura - 1) * perPage;
        const fim = inicio + perPage;
        const paginaInspeccoes = inspeccoesUnicas.slice(inicio, fim);

        setConfigLista({
          nextPage: paginaSegura + 1,
          hasPreviousPage: paginaSegura > 1,
          hasNextPage: paginaSegura < totalPages,
          totalItems,
        });

        setInspeccoes(paginaInspeccoes);
      } catch (err) {
        setInspeccoes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchInspeccoesDeduplicadas();

  }, [page, perPage, tipo, order, navigate, user?.funcao, inspectorId, provincia, dispatch]);


  return (
    <>
      <RegisterAccess page={'area de inspeccao agendada'} />

      <HeaderSession
        title='ESTABELECIMENTOS A SEREM INSPECCIONADOS'
        actions={true}
      // handleExportExcel={() => SolicitacoesLicenciamentoExcel(estabelecimentos)}
      // handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      {inspeccoes ?
        <ListaInspecoes
          inspeccoes={inspeccoes}
          inspectorId={inspectorId}
          setInspectorId={setInspectorId}
          provincia={provincia}
          setProvincia={setProvincia}
        >
          <Paginacao
            configLista={configLista}
            lista={inspeccoes}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}

          />
        </ListaInspecoes>
        :
        <TabelaLoading />
      }
    </>
  )
}
